// export const BASE_URL = "http://localhost:3001/";

// test

export const BASE_URL =
  // "https://kd0anqbw40.execute-api.ap-south-1.amazonaws.com/dev/";
  "https://6cmftltrh3.execute-api.ap-south-1.amazonaws.com/dev/";
